import { render, staticRenderFns } from "./GerarRelatoriosPretendentes.vue?vue&type=template&id=71ac9812&scoped=true&"
import script from "./GerarRelatoriosPretendentes.vue?vue&type=script&lang=js&"
export * from "./GerarRelatoriosPretendentes.vue?vue&type=script&lang=js&"
import style0 from "./GerarRelatoriosPretendentes.vue?vue&type=style&index=0&id=71ac9812&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ac9812",
  null
  
)

export default component.exports